export enum ProfileTabs {
  ABOUT_YOU = 'About you',
  CREDENTIALS = 'License & insurance',
  YOUR_BIO = 'Your bio',
  SPECIALTIES = 'Specialties',
  APPROACHES = 'Approaches',
  CLIENT_FOCUS = 'Client focus',
  IDENTITY = 'Identity'
}
